$(document).on('change', "[data-role='trigger']", function () {
  var $element = $(this);
  var $roles = $($element.parents('[data-row]').find("[data-role='receiver']"));
  $roles.html('') // cleanup

  $.each($element.find('option:selected').data('roles'), function (k, v) {
    let selected = $roles.data('selected') == v.id ? ' selected="selected"' : '';
    $roles.append(`<option${selected} value="${v.id}">${v.value}</option>`)
  });
});

$(document).on('turbo:load', function() {
  $("[data-role='trigger']").change()

  $('.toggle-terms-and-conditions').change(function() {
    var $this = $(this);
    var unChecked = !$this.prop('checked')

    $this.siblings('trix-editor, trix-toolbar').toggleClass('hidden', unChecked);

    if (unChecked) { $this.siblings('trix-editor').val('') }
  }).change()
});
